import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";

import Modal from '../generalcomponets/modal-mobile';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		estatus: state.recuperar.estatus,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoReset: () => {
			dispatch({ "type": "RECUPERAR_RESET_PASO" });
		},
		eventoInicioSesion: (estatus, dispositivo) => {
			if (estatus == "m") {
				dispatch({ "type": "EVENT_UMIGRADO_RFINAL_BTNINICIAR", "flujo": "UsuarioMigrado", "dispositivo": dispositivo });
			}
			else {
				dispatch({ "type": "EVENT_REGISTRO_FINALIZADO-ACEPTAR", "flujo": "UsuarioRegistro", "dispositivo": dispositivo });
			}

		}
	};
};

class Exito extends React.Component {

	state = {
		isModalOpened: false
	}

	componentDidMount() {
		if (this.props.dispositivo === 'app') {
			this.setState({ isModalOpened: true })
		} else {
			$('#modal-exito-correo').modal('show');
		}
	}

	enviarLogin = () => {
		this.props.pasoReset();
		if (this.props.dispositivo === 'app') {
			this.setState({ isModalOpened: false })
		} else {
			$('#modal-exito-correo').modal('hide');
		}
		if (this.props.estatus == "m" || this.props.estatus == "r") {
			this.props.eventoInicioSesion(this.props.estatus, this.props.dispositivo);
		}
		goTo("login");
	}

	render() {
		const isMoral = JSON.parse(localStorage.getItem("esMoral"));
		console.log("Es moral: ", isMoral, "tipo", typeof isMoral);
		localStorage.removeItem("esMoral");
		if (this.props.dispositivo === 'app') {
			return (this.state.isModalOpened &&
				<Modal closeModalFromChild={this.enviarLogin}>
					<div>
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
								<img src={require('../img/verified_user_success.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<label className="gnp-material-title-modal">¡Bienvenido!</label>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
								<div>
									<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
									<p className=" gnp-material-content-modal">De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la app Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.	</p>
								</div>
							</div>
							<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
								<button type="button" onClick={this.enviarLogin} className="pure-material-button-contained btn-full-width">Iniciar Sesión</button>
							</div>
						</div>
					</div>
				</Modal>)
		} else {
			return (
				<div className="modal fade modal-msj" id="modal-exito-correo" tabIndex="-1" role="dialog" aria-labelledby="modal-exito-correo" data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							{this.props.estatus != "nm" &&
								<div>
									<div className="">
										<h5 id='id-modal-title' className="text-center">¡Bienvenido!</h5>
									</div>
									<div className='txt-black'>
										Tu información se ha guardado satisfactoriamente. <br /><br />
										De ahora en adelante deberás acceder a tu sesión ingresando tu correo y nueva contraseña, mismo que podrás utilizar en la Aplicación Soy Cliente GNP. <br />
										Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios de call center.
									</div>
								</div>
							}
							{this.props.estatus == "nm" &&
								<div>
									<div className=''>
										<h5 id='id-modal-title' className="text-center">Cambio exitoso</h5>
									</div>
									<div className='txt-black'>
										<p>{isMoral == 2 ? "Tu contraseña fue restablecida con éxito, de ahora en adelante puedes utilizar tu nueva contraseña tanto en portal, la app Soy Cliente GNP, y en el portal Soy Cliente Empresarial | Sector Público." : "Tu contraseña fue restablecida con éxito, de ahora en adelante puedes utilizar tu nueva contraseña tanto en portal como en app Soy Cliente GNP."}</p>
									</div>
								</div>
							}
							<div className='text-center aceptar-cancelar-btn mt-20'>
								<button type='button' className='btn orange-btn' onClick={this.enviarLogin} data-dismiss='modal'>Iniciar Sesión</button>
							</div>
						</div>
					</div>
				</div>
			);
		}

	}
}

export default connect(mapState, mapDispatch)(Exito);


// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/exito.cmpt.js